import styled from 'styled-components';

import Button, { Props as ButtonProps } from '../Button';

type Props = { $iconOnly?: boolean } & ButtonProps;

export const StyledButton = styled(Button)<Props>`
  ${({ $iconOnly }) =>
    $iconOnly === true
      ? `&&&& {  
          min-width: 48px;
          max-width: 48px;
          padding-left: 2px;
          padding-right: 2px;
          justify-content: center;
        }`
      : `&&&& { justify-content: center; }`}
`;
